import React from 'react';

import cs from 'classnames';

import { ALERT_ACTIONS } from 'components/practice/charts/ClinicalNote/lib/alertAction';

import Button from '../Button/Button';
import Icon from '../Icon/Icon';

const InfoBox = ({
  color = 'warning',
  text,
  icon = 'info-filled',
  className,
  children,
  code,
  appointmentId,
  ...rest
}) => {
  const action = code ? ALERT_ACTIONS[code] : undefined;
  return (
    <div
      className={cs(
        'flex items-center !gap-2 !rounded !px-4 py-[6px]',
        `bg-${color}-50`,
        className
      )}
      {...rest}>
      <Icon icon={icon} color={color} />
      {text && <p className="z-50 text-sm leading-[22px] text-neutral-800">{text}</p>}
      {action && (
        <Button
          text={action?.text}
          size={action?.size || 'xs'}
          style="outlined"
          color={action?.color}
          icon={action?.icon}
          iconColor={action.color}
          onClick={() => action.onClick({ appointmentId })}
        />
      )}
      {children}
    </div>
  );
};

export default InfoBox;
